let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jLbI9")).then(() => parcelRequire('boEdP'));